export default __webpack_public_path__ + "static/media/aristo-detail-dark.312c25ee.svg";